import { Rows2, Rows3 } from 'lucide-react'

import { cn } from '@/shared/lib/cn'
import { useUiStore } from '@/shared/stores/ui-store'
import { useT } from '@/shared/i18n'

export interface DensityToggleProps {
  className?: string
  withLabel?: boolean
}

/** Compacta (fila de 32px, default) y comoda (44px). Se recuerda por usuario. */
export function DensityToggle({ className, withLabel = false }: DensityToggleProps) {
  const t = useT()
  const density = useUiStore((state) => state.density)
  const toggleDensity = useUiStore((state) => state.toggleDensity)

  const next = t(
    density === 'compact' ? 'appearance.density.nameComfortable' : 'appearance.density.nameCompact',
  )
  const switchLabel = t('appearance.density.switchTo', { densidad: next })

  return (
    <button
      type="button"
      onClick={toggleDensity}
      aria-label={switchLabel}
      title={switchLabel}
      data-testid="density-toggle"
      className={cn(
        'inline-flex h-7 items-center gap-1.5 rounded-[var(--radius-control)] px-2',
        'text-text-2 transition-colors duration-[var(--motion-fast)]',
        'hover:bg-surface-2 hover:text-text-1',
        className,
      )}
    >
      {density === 'compact' ? (
        <Rows3 size={14} aria-hidden="true" />
      ) : (
        <Rows2 size={14} aria-hidden="true" />
      )}
      {withLabel ? (
        <span className="text-xs">
          {t(
            density === 'compact' ? 'appearance.density.compact' : 'appearance.density.comfortable',
          )}
        </span>
      ) : null}
    </button>
  )
}
